/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response model for event creation.
 * @export
 * @interface EventResponse
 */
export interface EventResponse {
    /**
     * 
     * @type {string}
     * @memberof EventResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the EventResponse interface.
 */
export function instanceOfEventResponse(value: object): value is EventResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function EventResponseFromJSON(json: any): EventResponse {
    return EventResponseFromJSONTyped(json, false);
}

export function EventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function EventResponseToJSON(json: any): EventResponse {
    return EventResponseToJSONTyped(json, false);
}

export function EventResponseToJSONTyped(value?: EventResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'message': value['message'],
    };
}

